import React from "react";
import { Form, FormGroup } from "react-bootstrap";
import "./components.css";

const CommonInput = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  placeholder = "",
  required = false,
  className = "mb-3",
  isTextArea = false,
  rows = 4,
  disabled = false,
  error = null,
}) => {
  return (
    <div className={`${className}`}>
      {label && <Form.Label>{label}</Form.Label>}
      {isTextArea ? (
        <Form.Control
          as="textarea"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          rows={rows}
          required={required}
          disabled={disabled}
          className={`CommonInput ${error ? "is-invalid" : ""}`}
        />
      ) : (
        <Form.Control
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`CommonInput ${error ? "is-invalid" : ""}`}
        />
      )}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default CommonInput;
